'use strict';

exports.__esModule = true;
exports.parseUrl = parseUrl;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parseUrlParams(queryString) {
  var re = /([^&=]+)=([^&]*)/g;
  var param = void 0;
  var query = {};

  while ((param = re.exec(queryString)) !== null) {
    var key = decodeURIComponent(param[1]);
    var val = decodeURIComponent(param[2]);
    if (!query[key]) {
      // first value for key, keep as string
      query[key] = val;
    } else if (_lodash2.default.isArray(query[key])) {
      // more than one value already, push to the array
      query[key].push(val);
    } else {
      // the 2nd value for the key, turn into an array
      query[key] = [query[key], val];
    }
  }

  return query;
}

function parseUrl(url) {
  if (!url) {
    return {};
  }
  var urlRe = /((https?)\:\/\/)?([^\?\:\/#]+)(\:([0-9]+))?(\/[^\?\#]*)?(\?([^#]*))?(#.*)?/i;
  var match = url.match(urlRe);
  var port = match[5] || '';
  var search = match[8] ? '?' + match[8] : '';
  var ret = {
    full: url,
    protocol: match[2] || 'http:',
    host: port ? match[3] + ':' + port : match[3],
    hostname: match[3],
    port: port,
    path: match[6] || '/',
    search: search,
    hash: match[9] || ''

    // fix empty hash
  };if (ret.hash === '#' || ret.hash === '#!') {
    ret.hash = '';
  }

  ret.query = parseUrlParams(match[8]);
  return ret;
}
//# sourceMappingURL=urlUtils.js.map